module.exports = __webpack_public_path__ + "static/img/sec2-cont-img02.a22f0ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/xeogen/sec2-cont-img02.jpg
// module id = 3i2X
// module chunks = 0